
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftBottom75 as ObiThreewayAnalogInleftBottom75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-bottom-75.js';
 
 
 

 
 export const ObiThreewayAnalogInleftBottom75 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-bottom-75',
   elementClass: ObiThreewayAnalogInleftBottom75Element,
   events: {
     
   }
  });
 
 